import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
import { Chip, CircularProgress, Grid, Card, Backdrop, useTheme, Button } from '@mui/material';
import { Timeline } from 'antd';
import { EditTwoTone, ClockCircleOutlined, CheckCircleOutlined, SmileOutlined } from '@ant-design/icons';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

export default function ProductSelect({ DealerName, DealerCode, Order_Type }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);

    const [sectors, setSectors] = useState([]);
    const [selectedSector, setSelectedSector] = useState(null);
    const [hideSector, sethideSector] = useState(null);

    const [pg, setPG] = useState([]);
    const [selectedPG, setSelectedPG] = useState(null);
    const [hidePG, sethidePG] = useState(null);

    const [psg, setPSG] = useState([]);
    const [selectedPSG, setSelectedPSG] = useState(null);
    const [hidePSG, sethidePSG] = useState(null);

    const [hp, setHP] = useState([]);
    const [selectedHP, setSelectedHp] = useState(null);
    const [hideHP, sethideHp] = useState(null);

    const [product, setProduct] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [hideProduct, sethideProduct] = useState(null);

    const buttonStyle = {
        backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
    };

    useEffect(() => {
        fetchSectors();
    }, []);

    const fetchSectors = () => {
        setOpen(true);
        const data = { type: 'SectorCode' };
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setSectors(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const handleSectorSelect = (sector) => {
        setSelectedSector(sector);
        sethideSector(sector);

        setSelectedPG('');
        setSelectedPSG('');
        setSelectedHp('');
        setSelectedProduct('');

        sethidePG('');
        sethidePSG('');
        sethideHp('');

        setOpen(true);
        const data = { type: 'ProductGroup', Sector_Code: sector.Sector_Code };
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setPG(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const handlePGSelect = (pg) => {
        setSelectedPG(pg);
        sethidePG(pg);

        setSelectedPSG('');
        setSelectedHp('');
        setSelectedProduct('');

        sethidePSG('');
        sethideHp('');

        setOpen(true);
        const data = { type: 'ProductSubGroup', PG_Code: pg.PG_code };
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setPSG(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const handlePSGSelect = (psg) => {
        setSelectedPSG(psg);
        sethidePSG(psg);

        setSelectedHp('');
        setSelectedProduct('');

        sethideHp('');

        setOpen(true);
        const data = { type: 'HP', PSG_Code: psg.PSG_Code };
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setHP(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const handleHPSelect = (hp) => {
        setSelectedHp(hp);
        sethideHp(hp);

        setSelectedProduct('');

        setOpen(true);
        const data = { type: 'Product', HP: hp.HP, PSG_Code: selectedPSG.PSG_Code };
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setProduct(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const handleProduct = (product) => {
        setSelectedProduct(product);
    };

    const FindProductDetails = () => {

        if (!selectedSector) {
            Swal.fire({
                icon: "info",
                text: 'Select Sector !'
            });
        } else if (!selectedPG) {
            Swal.fire({
                icon: "info",
                text: 'Select PG !'
            });
        } else if (!selectedPSG) {
            Swal.fire({
                icon: "info",
                text: 'Select PSG !'
            });
        } else if (!selectedHP) {
            Swal.fire({
                icon: "info",
                text: 'Select HP !'
            });
        } else if (!selectedProduct) {
            Swal.fire({
                icon: "info",
                text: 'Select Product !'
            });
        } else if (!DealerCode) {
            Swal.fire({
                icon: "info",
                text: 'Select Dealer !'
            });
        } else if (!Order_Type) {
            Swal.fire({
                icon: "info",
                text: 'Select Order Type !'
            });
        } else {
            navigate('/Home/Spares/Spares_Identification_Software/spare_selection', {
                state: {
                    Dealer_Name: DealerName,
                    Dealer_Code: DealerCode,
                    Order_Type: Order_Type,

                    Sector_Code: selectedSector.Sector_Code,
                    Sector_Name: selectedSector.Sector_Name,

                    PG_code: selectedPG.PG_code,
                    PG_Name: selectedPG.PG_Name,

                    PSG_Code: selectedPSG.PSG_Code,
                    PSG_Name: selectedPSG.PSG_Name,

                    HP: selectedHP.HP,

                    Itemcode: selectedProduct.Itemcode,
                    ITEMDESCRIPTION: selectedProduct.ITEMDESCRIPTION,
                }
            });
        }
    };

    return (
        <>
            <div className="" style={{ display: 'flex', flexDirection: 'column' }}>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <div className="row">
                    <div className="col-md-9 mb-3">
                    
                        {!hideSector && (
                            <Card className="shadow bg-white rounded" sx={{ padding: '30px' }} >
                                <b>Select Sector :</b>
                                <Grid container spacing={1.2}>
                                    {sectors && sectors.length > 0 ? (
                                        (sectors && sectors.map((sector) => (
                                            <Grid item key={sector.Sector_Code}>
                                                <Chip
                                                    label={sector.Sector_Name}
                                                    variant={selectedSector === sector ? "filled" : "outlined"}
                                                    onClick={() => handleSectorSelect(sector)}
                                                    sx={{
                                                        color: selectedSector === sector ? theme.palette.primary.contrastText : theme.palette.primary.main,
                                                        bgcolor: selectedSector === sector ? theme.palette.primary.main : "transparent",
                                                    }}
                                                />
                                            </Grid>
                                        )))
                                    ) : (
                                        <Grid item>
                                            <Chip
                                                icon={<ReportProblemOutlinedIcon />}
                                                label="Sector Code Not Found.!"
                                                variant="filled"
                                                sx={{
                                                    background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
                                                    color: '#fff',
                                                    fontWeight: 'bold',
                                                    fontSize: '1rem',
                                                    padding: '10px 20px',
                                                    borderRadius: '12px',
                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                    '& .MuiChip-icon': {
                                                        color: '#fff',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Card>
                        )}

                        {!hidePG && (
                            <>
                                {selectedSector && (
                                    <Card className="shadow bg-white rounded" sx={{ padding: '30px' }}>
                                        <b>Select Product Group :</b>
                                        <Grid container spacing={1.2}>
                                            {pg && pg.length > 0 ? (
                                                (pg && pg.map((pg) => (
                                                    <Grid item key={pg.PG_code}>
                                                        <Chip
                                                            label={pg.PG_Name}
                                                            variant={selectedPG === pg ? "filled" : "outlined"}
                                                            onClick={() => handlePGSelect(pg)}
                                                            sx={{
                                                                color: selectedPG === pg ? theme.palette.primary.contrastText : theme.palette.primary.main,
                                                                bgcolor: selectedPG === pg ? theme.palette.primary.main : "transparent",
                                                            }}
                                                        />
                                                    </Grid>
                                                )))
                                            ) : (
                                                <Grid item>
                                                    <Chip
                                                        icon={<ReportProblemOutlinedIcon />}
                                                        onClick={() => sethideSector(null)}
                                                        label={"Product Group Not Found.!"}
                                                        variant="filled"
                                                        sx={{
                                                            background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
                                                            color: '#fff',
                                                            fontWeight: 'bold',
                                                            fontSize: '1rem',
                                                            padding: '10px 20px',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                            '& .MuiChip-icon': {
                                                                color: '#fff',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Card>
                                )}
                            </>
                        )}

                        {!hidePSG && (
                            <>
                                {selectedPG && (
                                    <Card className="shadow bg-white rounded" sx={{ padding: '30px' }}>
                                        <b>Select Product Sub Group :</b>
                                        <Grid container spacing={1.2}>
                                            {psg && psg.length > 0 ? (
                                                (psg && psg.map((psg) => (
                                                    <Grid item key={psg.PSG_Code}>
                                                        <Chip
                                                            label={psg.PSG_Name}
                                                            variant={selectedPSG === psg ? "filled" : "outlined"}
                                                            onClick={() => handlePSGSelect(psg)}
                                                            sx={{
                                                                color: selectedPSG === psg ? theme.palette.primary.contrastText : theme.palette.primary.main,
                                                                bgcolor: selectedPSG === psg ? theme.palette.primary.main : "transparent",
                                                            }}
                                                        />
                                                    </Grid>
                                                )))
                                            ) : (
                                                <Grid item>
                                                    <Chip
                                                        icon={<ReportProblemOutlinedIcon />}
                                                        onClick={() => sethidePG(null)}
                                                        label={"Product Sub Group Not Found.!"}
                                                        variant="filled"
                                                        sx={{
                                                            background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
                                                            color: '#fff',
                                                            fontWeight: 'bold',
                                                            fontSize: '1rem',
                                                            padding: '10px 20px',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                            '& .MuiChip-icon': {
                                                                color: '#fff',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Card>
                                )}
                            </>
                        )}

                        {!hideHP && (
                            <>
                                {selectedPSG && (
                                    <Card className="shadow bg-white rounded" sx={{ padding: '30px' }}>
                                        <b>Select HP :</b>
                                        <Grid container spacing={1.2}>
                                            {hp && hp.length > 0 ? (
                                                (hp && hp.map((hp) => (
                                                    <Grid item key={hp.HP}>
                                                        <Chip
                                                            label={hp.HP}
                                                            variant={selectedHP === hp ? "filled" : "outlined"}
                                                            onClick={() => handleHPSelect(hp)}
                                                            sx={{
                                                                color: selectedHP === hp ? theme.palette.primary.contrastText : theme.palette.primary.main,
                                                                bgcolor: selectedHP === hp ? theme.palette.primary.main : "transparent",
                                                            }}
                                                        />
                                                    </Grid>
                                                )))
                                            ) : (
                                                <Grid item>
                                                    <Chip
                                                        icon={<ReportProblemOutlinedIcon />}
                                                        onClick={() => sethidePSG(null)}
                                                        label={"HP Not Found!"}
                                                        variant="filled"
                                                        sx={{
                                                            background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
                                                            color: '#fff',
                                                            fontWeight: 'bold',
                                                            fontSize: '1rem',
                                                            padding: '10px 20px',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                            '& .MuiChip-icon': {
                                                                color: '#fff',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Card>
                                )}
                            </>
                        )}

                        {selectedHP && (
                            <Card className="shadow bg-white rounded" sx={{ padding: '30px' }}>
                                <b>Select Product :</b>
                                <Grid container spacing={1.2}>
                                    {product && product.length > 0 ? (
                                        (product && product.map((product) => (
                                            <Grid item key={product.Itemcode}>
                                                <Chip
                                                    label={<>{product.Itemcode} | {product.ITEMDESCRIPTION}</>}
                                                    variant={selectedProduct === product ? "filled" : "outlined"}
                                                    onClick={() => handleProduct(product)}
                                                    sx={{
                                                        color: selectedProduct === product ? theme.palette.primary.contrastText : theme.palette.primary.main,
                                                        bgcolor: selectedProduct === product ? theme.palette.primary.main : "transparent",
                                                    }}
                                                />
                                            </Grid>
                                        )))
                                    ) : (
                                        <Grid item>
                                            <Chip
                                                icon={<ReportProblemOutlinedIcon />}
                                                onClick={() => sethideHp(null)}
                                                label={"Product Not Found.!"}
                                                variant="filled"
                                                sx={{
                                                    background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
                                                    color: '#fff',
                                                    fontWeight: 'bold',
                                                    fontSize: '1rem',
                                                    padding: '10px 20px',
                                                    borderRadius: '12px',
                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                    '& .MuiChip-icon': {
                                                        color: '#fff',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Card>
                        )}

                    </div>
                    <div className="col-md-3">
                        <Card className="shadow bg-white rounded" sx={{ padding: '30px', position: 'sticky', zIndex: '1000' }} >
                            <Timeline
                                items={[
                                    {
                                        color: selectedSector ? 'green' : 'red',
                                        dot: selectedSector ? <CheckCircleOutlined /> : <ClockCircleOutlined />,
                                        children: (
                                            <>
                                                <u><b>Sector</b></u>
                                                <br />
                                                <span style={{ wordWrap: 'break-word', maxWidth: '100%' }}>
                                                    {selectedSector && (
                                                        <>
                                                            {selectedSector.Sector_Name} &nbsp;
                                                            <EditTwoTone onClick={() => sethideSector(null)} />
                                                        </>
                                                    )}
                                                </span>
                                            </>
                                        )
                                    },
                                    {
                                        color: selectedPG ? 'green' : 'red',
                                        dot: (selectedSector ? (
                                            selectedPG ? <CheckCircleOutlined /> : <ClockCircleOutlined />
                                        ) : null),
                                        children: (
                                            <>
                                                <u><b>Product Group</b></u>
                                                <br />
                                                <span style={{ wordWrap: 'break-word', maxWidth: '100%' }}>
                                                    {selectedPG && (
                                                        <>
                                                            {selectedPG.PG_Name} &nbsp;
                                                            <EditTwoTone onClick={() => sethidePG(null)} />
                                                        </>
                                                    )}
                                                </span>
                                            </>
                                        )
                                    },
                                    {
                                        color: selectedPSG ? 'green' : 'red',
                                        dot: (selectedPG ? (
                                            selectedPSG ? <CheckCircleOutlined /> : <ClockCircleOutlined />
                                        ) : null),
                                        children: (
                                            <>
                                                <u><b>Product Sub Group</b></u>
                                                <br />
                                                <span style={{ wordWrap: 'break-word', maxWidth: '100%' }}>
                                                    {selectedPSG && (
                                                        <>
                                                            {selectedPSG.PSG_Name} &nbsp;
                                                            <EditTwoTone onClick={() => sethidePSG(null)} />
                                                        </>
                                                    )}
                                                </span>
                                            </>
                                        )
                                    },
                                    {
                                        color: selectedHP ? 'green' : 'red',
                                        dot: (selectedPSG ? (
                                            selectedHP ? <CheckCircleOutlined /> : <ClockCircleOutlined />
                                        ) : null),
                                        children: (
                                            <>
                                                <u><b>HP</b></u>
                                                <br />
                                                <span style={{ wordWrap: 'break-word', maxWidth: '100%' }}>
                                                    {selectedHP && (
                                                        <>
                                                            {selectedHP.HP} &nbsp;
                                                            <EditTwoTone onClick={() => sethideHp(null)} />
                                                        </>
                                                    )}
                                                </span>
                                            </>
                                        )
                                    },
                                    {
                                        color: '#00CCFF',
                                        dot: (selectedHP ? (
                                            selectedProduct ? <SmileOutlined /> : <ClockCircleOutlined />
                                        ) : null),
                                        children: (
                                            <>
                                                <u><b>Product</b></u>
                                                <br />
                                                <span style={{ wordWrap: 'break-word', maxWidth: '100%' }}>
                                                    {selectedProduct && selectedProduct.ITEMDESCRIPTION}
                                                </span>
                                            </>
                                        )
                                    }
                                ]}
                            />
                            <center>
                                <Button fullWidth variant="contained" endIcon={<RemoveRedEyeRoundedIcon />} onClick={FindProductDetails}
                                    style={buttonStyle} ><b>View</b></Button>
                            </center>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    );
}
